import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 24px 8px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: #59249b;
`;

export const Title = styled.h3`
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: 700;
  color: #333333;
`;

export const Description = styled.p`
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 1.4;
`;

export const RecipientsList = styled.ul`
  margin: 0 0 16px;
  padding: 0;
  list-style: none;
  text-align: left;
  color: #59249b;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.8;

  li {
    position: relative;
    padding-left: 18px;
  }

  li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #59249b;
  }
`;

export const FooterNote = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 1.4;

  strong {
    font-weight: 700;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
